<template>
  <div class="hm__slug">
    <div class="hm__slug-pic" aria-hidden="true">
      <slot name="img"/>
    </div>
    <div class="hm__slug-title"><slot name="title"/></div>
    <p class="hm__slug-text"><slot name="text"/></p>
  </div>
</template>
<script>
export default {
  name: 'HMSlug',
}
</script>

<style scoped>
.hm__slug {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px 38px ;
  border-radius: 16px;
  border: 1px solid #EFF4F9;
  background-color: #FCFDFE;
}

.hm__slug-pic {
  width: 90px;
  height: 90px;
  margin-bottom: 11px;
  line-height: 0;
}

.hm__slug-title {
  margin-bottom: 16px;
  color: #76A9B4;
  text-align: center;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
}

.hm__slug-text {
  color: #BCC5CA;
  text-align: center;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
}
</style>